// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3lZao","checkboxCol":"Table_checkboxCol__2H2X0","emailCol":"Table_emailCol__2sy66","actionCol":"Table_actionCol__3byE6"};